import { Mouvement } from '@mairistem/comptabilite';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class InformationsRattachementPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.INFORMATIONS_RATTACHEMENT;
    this.defaultSize = 6;
    this.icon = { name: 'linkify' };
  }

  getLibelle = () => 'Informations de rattachement';

  isEmpty = (data: Mouvement) => (!data?.lignes?.find((ligne) => ligne?.exerRattachement)
    && !data?.lignes?.find((ligne) => ligne?.idLigneOriginePes)
    && !data?.lignes?.find((ligne) => ligne?.naturePieceOrigine)
    && !data?.lignes?.find((ligne) => ligne?.pieceOrigine));
}

export default InformationsRattachementPanel;
